interface SpinnerProps {
  label?: string;
}

/** Indeterminate loading indicator with an accessible label. */
export function Spinner({ label = 'Loading' }: SpinnerProps) {
  return (
    <div
      className="flex flex-col items-center gap-4 text-call-dim"
      role="status"
      aria-live="polite"
    >
      <span
        className="size-10 animate-spin rounded-full border-[3px] border-line-soft border-t-blue motion-reduce:animate-none"
        aria-hidden="true"
      />
      <span className="text-sm">{label}</span>
    </div>
  );
}
